import { PdProductItem } from 'interfaces/line-item';
import { CartUpsellProductDetails } from 'interfaces/product';

/**
 * Calculates the strike price for a product item
 */
export const calculateStrikePrice = (
  item:
    | PdProductItem
    | CartUpsellProductDetails
    | Partial<PdProductItem>
    | Partial<CartUpsellProductDetails>,
  quantity = 1
): number | null => {
  if (item.compareAtPrice && item.compareAtPrice !== item.price && item.compareAtPrice > 0) {
    return item.compareAtPrice * quantity;
  }

  if (item.defaultPrice && item.defaultPrice !== item.price && item.defaultPrice > 0) {
    return item.defaultPrice * quantity;
  }

  return null;
};
